import React from 'react';
import { Card } from 'react-bootstrap';
import { Row, Col } from 'react-bootstrap';
// import { Container } from 'react-bootstrap';
import './Products.css';

import prodtouchbg from '../images/PageImg/ProductTouch-page-bg.jpg'
import HeaderSlide from '../components/HeaderSlide'
import { TouchGGPCapImg } from '../assets/ProductTouchData';
import { TouchGFPCapImg } from '../assets/ProductTouchData';
import { TouchPGPCapImg } from '../assets/ProductTouchData';

import { TouchGGPCapTxt } from '../assets/ProductTouchData';
import { TouchGFPCapTxt } from '../assets/ProductTouchData';
import { TouchPGPCapTxt } from '../assets/ProductTouchData';

import { GoTopBtn } from '../components/GoTopBtn';

function ProductTouch() {
  // console.log("get into ProductTouch()");
  return (
    <div className='products-page container-fluid'>
      <div className='productheader'
        style={{ backgroundImage: `url(${prodtouchbg})`, height: "70vh" }} >
        {/* style={{ backgroundImage: `url(${prodtouchbg})`, height: "550px" }} > */}
        {/* style={{ backgroundImage: `url(${prodtouchbg})`, height: "auto" }} > */}
        <HeaderSlide text={'Product / Touch'} />
        <h4 className='text-dark'>&nbsp;images/PageImg/ProductTouch-page-bg.jpg</h4>
      </div>
      {/* <br /> */}

      {/* Product Glass+Glass PCap Touch Panel */}
      <section id='producttouchggpcap' className='product-block bg-primary-subtle'>
        <h2 className='title-holder fs-1 fw-bold text-primary'>G+G投射电容触摸屏(G+G PCap Touch Panel)</h2>
        {/* <Container fluid> */}
        <Row>
          <Col lg={5} className='flex-column justify-content-center'> {
            TouchGGPCapImg.map(idx => {
              return (
                <Row key={idx.id} className='d-flex'>
                  <img src={idx.image} style={{ height: 'auto' }} alt='' />
                  {/* <img src={idx.image} style={{ width: '60vw' }} alt='' /> */}
                  <h5 className='text-warning-emphasis'>{idx.alt}</h5>
                </Row>
              );
            })
          } </Col>
          <Col lg={7} className='d-flex flex-column justify-content-around'> {
            // <Row> {
            TouchGGPCapTxt.map((pcap) => {
              return (
                <Row key={pcap.id} style={{ marginLeft: '-25px', width: '57.5vw' }}>
                  <Card className='bg-warning-subtle border-1'>
                    <br />
                    <Card.Title className='text-center fs-3 text-success'> {pcap.title} </Card.Title>
                    <Card.Text style={{ whiteSpace: 'pre' }}> {pcap.text} </Card.Text>
                    {/* <Card.Text className='fs-4' style={{ whiteSpace: 'pre' }}> {idx.text} </Card.Text> */}
                  </Card>
                </Row>
              )
            })
            // } </Row>
          } </Col>
        </Row>
        {/* </Container> */}
      </section>

      {/* Product Glass+FilmFilm PCap Touch Panel */}
      <section id='producttouchgfpcap' className='product-block bg-warning-subtle'>
        <h2 className='title-holder fs-1 fw-bold text-success'>GFF PCap Touch Panel</h2>
        <Row>
          <Col lg={7} className='d-flex flex-column justify-content-around'> {
            TouchGFPCapTxt.map((pcap) => {
              return (
                <Row key={pcap.id} className='holder'>
                  <Card className='bg-primary-subtle border-1' style={{ marginLeft: '11px' }}>
                    <br />
                    <Card.Title className='text-center fs-3 text-success'> {pcap.title} </Card.Title>
                    <Card.Text style={{ whiteSpace: 'pre' }}> {pcap.text} </Card.Text>
                    {/* <Card.Text className='fs-4' style={{ whiteSpace: 'pre' }}> {idx.text} </Card.Text> */}
                  </Card>
                </Row>
              )
            })
          } </Col>
          <Col lg={5} className='flex-column justify-content-center'> {
            TouchGFPCapImg.map(idx => {
              return (
                <Row key={idx.id} className='d-flex'>
                  <img src={idx.image} className='img-fluid' style={{ height: 'auto' }} alt='' />
                  {/* <img src={idx.image} style={{ width: '60vw' }} alt='' /> */}
                  <h5 className='text-warning-emphasis'>{idx.alt}</h5>
                </Row>
              );
            })
          } </Col>
        </Row>
        {/* </Container> */}
      </section>

      {/* Product Plastic+Glass PCap Touch Panel */}
      <section id='producttouchpgcap' className='product-block bg-primary-subtle' >
        <h2 className='title-holder fs-1 fw-bold text-primary'>P+G PCap Touch Panel</h2>
        <Row>
          <Col lg={5} className='flex-column justify-content-center'> {
            TouchPGPCapImg.map(idx => {
              return (
                <Row key={idx.id} className='d-flex'>
                  <img src={idx.image} className='img-fluid' style={{ height: 'auto' }} alt='' />
                  {/* <img src={idx.image} style={{ width: '60vw' }} alt='' /> */}
                  <h5 className='text-warning-emphasis'>{idx.alt}</h5>
                </Row>
              );
            })
          } </Col>
          <Col lg={7} className='d-flex flex-column justify-content-around'> {
            TouchPGPCapTxt.map((pcap) => {
              return (
                <Row key={pcap.id} style={{ marginLeft: '-25px', width: '57.5vw' }}>
                  {/* <Row key={tdm.id} className='holder' style={{ marginLeft: '-25px' }}> */}
                  <Card className='bg-warning-subtle border-1 p-0 m-0'>
                    <br />
                    <Card.Title className='text-center fs-2 text-primary'> {pcap.title} </Card.Title>
                    <Card.Text style={{ whiteSpace: 'pre' }}> {pcap.text} </Card.Text>
                  </Card>
                </Row>
              )
            })
          } </Col>
        </Row>
        {/* </Container> */}
      </section>

      <div> < GoTopBtn /> </div>
    </ div >
  )
}

export default ProductTouch;

// import { TouchTopImg } from '../assets/ProductTouchData';
/* Product PCap Touch Top Image */
/*
<section id='producttouchtop' className='block product-block bg-warning-subtle'> {
  // <Container fluid>
  <Row className='d-flex justify-content-around'> {
    TouchTopImg.map(idx => {
      return (
        <Col lg={3} key={idx.id} className='flex'>
          <img src={idx.image} className='img-fluid' style={{ height: 'auto' }} alt='' />
          // <img src={idx.image} style={{ height: '65vh', width: '55vw' }} alt='' />
          <h5 className='text-warning-emphasis'>{idx.alt}</h5>
        </Col>
      )
    })
  } </Row>
  // </Container>
} </section>
*/
